var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSign = function SvgLogoSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F4EAD",
    d: "M40 73V6l16.5 51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBCAE6",
    d: "m40 6 40 51.7H56.5L40 6Zm0 0L23.5 57.7H0L40 6Z"
  }))));
};
export { SvgLogoSign as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MCA4MCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMxRjRFQUQiIGQ9Ik00MCA3M1Y2bDE2LjUgNTEuOHoiLz4KICAgIDxwYXRoIGZpbGw9IiNCQkNBRTYiIGQ9Im00MCA2IDQwIDUxLjdINTYuNUw0MCA2Wm0wIDBMMjMuNSA1Ny43SDBMNDAgNloiLz4KICA8L2c+Cjwvc3ZnPg==";